import { Form} from "react-bootstrap";

import doctor1 from "../assets/img/avatars/logo_unknown_doctor.jpg";

const caseInsensitiveSort = ({ row1, row2, columnName }) => {
    const rowOneColumn = row1.values[columnName];
    const rowTwoColumn = row2.values[columnName];

    if (rowOneColumn === null && rowTwoColumn === null) {
        return 0;
    }

    if (rowOneColumn === null || rowOneColumn === undefined) {
        return -1;
    }

    if (rowTwoColumn === null || rowTwoColumn === undefined) {
        return 1;
    }

    if (isNaN(rowOneColumn)) {
        return String(rowOneColumn).toUpperCase() >
            String(rowTwoColumn).toUpperCase()
            ? 1
            : -1;
    }
    return Number(rowOneColumn) > Number(rowTwoColumn) ? 1 : -1;
};

export { caseInsensitiveSort };


const getAssigneeAvatarDisplay = (assignees) => {
    if (assignees && assignees.length > 0) {
      return assignees.map((assignee, i) => {
        return (
          <img
            key={i}
            src={assignee.photoUrl == null || assignee.photoUrl === '' ? doctor1 : assignee.photoUrl}
            width="20"
            height="20"
            className="rounded-circle"
            alt={assignee.firstName + ' ' + assignee.lastName}
            title={assignee.firstName + ' ' + assignee.lastName}
          />
        )
      }, this);
    }
  
    return "";
  }

export { getAssigneeAvatarDisplay };

export function ExpiresColumnCheckboxFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  return (
    <>
    <Form.Check 
      size="sm"
      className="mt-2"
      style={{display: "inline"}}
      value={ filterValue || "excludeGreaterThan30Days"}
      onChange={(e) => {
        setFilter(e.target.checked ? "includeAll" : "excludeGreaterThan30Days");
      }}
      />&nbsp;
      <Form.Label style={{display: "inline", fontSize: "0.9em"}}>Show outdated items (expired &gt; 30 days ago)</Form.Label> 
    </>
  );
}

export function customExpiresFilter(fieldName) {
  return function customExpiresFilterInner(rows, id, filterValue) {
    if (filterValue !== "excludeGreaterThan30Days") return rows;

    const now = new Date();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);
    const oneDay = 24 * 60 * 60 * 1000;

    return rows.filter((row) => {
      if (row.original[fieldName])
      {
        const components = row.original[fieldName].split("-");
        if (components.length === 3)
        {
          const expirationDate = new Date(components[0], components[1] - 1, components[2]);
          const daysAgo = (now - expirationDate) / oneDay;
          return daysAgo <= 30;
        }
      }

      return true;
    });
  }
}

export function ExpiresAndArchivedColumnCheckboxFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  return (
    <>
    <Form.Check 
      size="sm"
      className="mt-2"
      style={{display: "inline"}}
      value={ filterValue || "excludeGreaterThan30Days"}
      onChange={(e) => {
        setFilter(e.target.checked ? "includeAll" : "excludeGreaterThan30Days");
      }}
      />&nbsp;
      <Form.Label style={{display: "inline", fontSize: "0.9em"}}>Show outdated items (expired &gt; 30 days ago or archived)</Form.Label> 
    </>
  );
}

export function customExpiresAndArchivedFilter(fieldName) {
  return function customExpiresAndArchivedFilterInner(rows, id, filterValue) {
    if (filterValue !== "excludeGreaterThan30Days") return rows;

    const now = new Date();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);
    const oneDay = 24 * 60 * 60 * 1000;

    return rows.filter((row) => {
      if (row.original.archived)
      {
        return false;
      }

      if (row.original[fieldName])
      {
        const components = row.original[fieldName].split("-");
        if (components.length === 3)
        {
          const expirationDate = new Date(components[0], components[1] - 1, components[2]);
          const daysAgo = (now - expirationDate) / oneDay;
          return daysAgo <= 30;
        }
      }

      return true;
    });
  }
}

export function getReminderSentDisplay(reminderSent) {
  if (reminderSent)
  {
    var parts = reminderSent.split("-");
    const reminderSentDateObj = new Date(parts[0], parts[1] - 1, parts[2]);  // Avoid the UTC->local timezone translation issue with js
    return new Date(reminderSentDateObj).toLocaleDateString("en-US");
  }

  return '';
}